import { render, staticRenderFns } from "./BikyConfigKnowledgeBaseItem.vue?vue&type=template&id=13499f22&scoped=true&"
import script from "./BikyConfigKnowledgeBaseItem.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigKnowledgeBaseItem.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigKnowledgeBaseItem.vue?vue&type=style&index=0&id=13499f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13499f22",
  null
  
)

export default component.exports